"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
var ApiError;
(function (ApiError) {
    ApiError["DeclineAcceptedMatching"] = "DECLINE_ACCEPTED_MATCHING";
})(ApiError = exports.ApiError || (exports.ApiError = {}));
